/**
 * Класс бейджа статуса договора по значению справочника «Статусы договоров».
 * Серые: новый, отменен, приостановлен.
 * Жёлтые: в работе.
 * Зелёный: завершен.
 * Совместимость со старыми значениями: active, completed, paused и т.д.
 * @param {string|null|undefined} status
 * @returns {'object-status-not-started'|'object-status-in-progress'|'object-status-completed'}
 */
export function getContractStatusClass(status) {
  if (status == null || String(status).trim() === '') return 'object-status-not-started'
  const s = String(status).toLowerCase().trim()
  if (s === 'работы завершены' || s === 'завершен' || s === 'завершён' || s === 'completed') return 'object-status-completed'
  if (s === 'новый' || s === 'отменен' || s === 'отменён' || s === 'не в работе' || s === 'не подписан' || s === 'paused' || s === 'приостановлен') return 'object-status-not-started'
  if (s === 'в работе' || s === 'в подготовке' || s === 'в рассмотрении' || s === 'подписан' ||
      s === 'active' || s === 'активный' || s === 'действующий') return 'object-status-in-progress'
  return 'object-status-not-started'
}
